/** Will read the `routes.admin` config and appropriately handle `"/"` admin paths */
export { formatAdminURL } from 'payload/shared'
